(() => {
  const init = () => {
    document.querySelectorAll('[data-lbr-menu-toggle]').forEach((button) => {
      if (button.dataset.lbrBound) return;
      button.dataset.lbrBound = 'true';
      button.addEventListener('click', () => {
        const drawer = document.querySelector('[data-lbr-mobile-drawer]');
        if (!drawer) return;
        const open = drawer.classList.toggle('is-open');
        button.setAttribute('aria-expanded', String(open));
      });
    });

    document.querySelectorAll('[data-lbr-qty]').forEach((wrapper) => {
      if (wrapper.dataset.lbrBound) return;
      wrapper.dataset.lbrBound = 'true';
      const input = wrapper.querySelector('input[type="number"]');
      wrapper.querySelector('[data-lbr-minus]')?.addEventListener('click', () => {
        if (!input) return;
        input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      wrapper.querySelector('[data-lbr-plus]')?.addEventListener('click', () => {
        if (!input) return;
        const max = Number(input.max || 999);
        input.value = Math.min(max, Number(input.value || 1) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    document.querySelectorAll('.lbr form[action*="/cart/add"]').forEach((form) => {
      if (form.dataset.lbrCartBound) return;
      form.dataset.lbrCartBound = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (form.dataset.lbrSubmitting === 'true') return;
        form.dataset.lbrSubmitting = 'true';
        const submitter = event.submitter || form.querySelector('[type="submit"]');
        if (submitter) submitter.disabled = true;
        const formData = new FormData(form);
        const variantId = Number(formData.get('id'));
        try {
          const addResponse = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          });
          if (!addResponse.ok) throw new Error('Cart add failed');
          const cartUrl = window.routes?.cart_url ? window.routes.cart_url + '.js' : '/cart.js';
          const cart = await fetch(cartUrl).then((response) => response.json());
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: variantId,
              cartData: cart,
            });
          }
          window.setTimeout(() => { window.location.href = window.routes?.cart_url || '/cart'; }, 250);
        } catch (error) {
          form.dataset.lbrSubmitting = 'false';
          if (submitter) submitter.disabled = false;
          HTMLFormElement.prototype.submit.call(form);
        }
      });
    });

    const sticky = document.querySelector('[data-lbr-sticky-atc]');
    const mainForm = document.querySelector('.lbr-pdp-form');
    if (sticky && mainForm && !sticky.dataset.lbrBound) {
      sticky.dataset.lbrBound = 'true';
      sticky.querySelector('button')?.addEventListener('click', () => {
        mainForm.requestSubmit();
      });
    }

    const resetSticky = document.querySelector('[data-lbr-reset-sticky]');
    if (resetSticky && !resetSticky.dataset.lbrBound) {
      resetSticky.dataset.lbrBound = 'true';
      const heroActions = document.querySelector('.lbr-landing-hero .lbr-home-hero__actions');
      const finalCta = document.querySelector('.lbr-reset-final');
      const footer = document.querySelector('.lb-footer');
      let scheduled = false;
      const intersectsViewport = (element) => {
        if (!element) return false;
        const rect = element.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      };
      const updateResetSticky = () => {
        scheduled = false;
        const afterHero = heroActions && heroActions.getBoundingClientRect().bottom < 0;
        const show = Boolean(afterHero && !intersectsViewport(finalCta) && !intersectsViewport(footer));
        resetSticky.classList.toggle('is-visible', show);
        resetSticky.setAttribute('aria-hidden', String(!show));
      };
      const scheduleResetSticky = () => {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(updateResetSticky);
      };
      window.addEventListener('scroll', scheduleResetSticky, { passive: true });
      window.addEventListener('resize', scheduleResetSticky);
      scheduleResetSticky();
    }
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
